var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _this = this;
import { makeStyles, styled, Tooltip, withStyles } from "@material-ui/core";
import { Linked, useBoundLink, useLinked } from "@type-r/react";
import { PrimaryButton, Button, div, FormSelect, Option, Input, span, BaseCheckbox, Column } from "lqx-react";
import React, { useEffect, useRef } from "react";
import { getAuthorizationBearer, getPlatformCode } from "./api/endpoint";
export var InputWithMask = function (_a) {
    var onBlur = _a.onBlur, mask = _a.mask, number = _a.number, $value = _a.$value, props = __rest(_a, ["onBlur", "mask", "number", "$value"]);
    var $isEditing = useLinked(false);
    var realInputParentRef = useRef(null);
    var $mask = useBoundLink(mask);
    useEffect(function () {
        if (realInputParentRef.current)
            realInputParentRef.current.querySelector('input').focus();
    }, [$isEditing.value]);
    var onRealInputBlur = function (e) {
        $isEditing.set(false);
        if (onBlur)
            onBlur(e);
    };
    var onReadInputFocus = function () {
        $isEditing.set(true);
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { hidden: !$isEditing.value, ref: realInputParentRef },
            React.createElement("div", null,
                React.createElement(Input, __assign({ number: number }, props, { "$value": $value, onBlur: onRealInputBlur })))),
        React.createElement(ReadValueContainer, { hidden: $isEditing.value },
            React.createElement(Input, __assign({}, props, { onFocus: onReadInputFocus }, { "$value": $mask }))));
};
var ReadValueContainer = div({
    '& input': {
        textAlign: 'right'
    }
});
export var WorkflowBody = div({
    marginTop: 15,
    paddingBottom: '70px'
});
export var WorkflowTitle = div({
    marginLeft: 5,
    marginTop: 10,
    color: '#3d6889',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize'
});
export var WorkflowRow = div({
    marginBottom: 20
});
export var WorkflowFooter = div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    position: 'fixed',
    bottom: '0px',
    right: '0px',
    left: '0px',
    // width: '100%',
    minHeight: '3vh',
    background: 'white',
    // marginLeft: '16px',
    paddingTop: '10px'
});
export var WorkflowColumn = styled(Column)({
    minWidth: '400px'
});
export var RightAlignedButtons = div({
    marginLeft: 'auto',
    marginRight: '0px'
});
export var BackButton = styled(Button)({
    fontFamily: 'Montserrat',
    fontSize: 12,
    marginBottom: '10px',
    backgroundColor: 'white',
    color: 'gray',
    borderRadius: '20px',
    border: '1px solid',
    height: '25px',
    minWidth: '200px',
    marginLeft: 'auto'
});
export var CancelButton = styled(Button)({
    fontFamily: 'Montserrat',
    fontSize: 12,
    marginBottom: '10px',
    backgroundColor: 'transparent',
    color: '#4197d6',
    borderRadius: '20px',
    border: '0px',
    height: '25px',
    width: 'fit-content',
    '&:hover': {
        fontFamily: 'Montserrat',
        fontSize: 12,
        marginBottom: '10px',
        backgroundColor: 'transparent',
        color: '#4197d6',
        borderRadius: '20px',
        border: '0px',
        height: '25px',
    },
    '&:active': {
        fontFamily: 'Montserrat',
        fontSize: 12,
        marginBottom: '10px',
        backgroundColor: 'transparent',
        color: '#4197d6',
        borderRadius: '20px',
        border: '0px',
        height: '25px',
    },
    '&:focus': {
        fontFamily: 'Montserrat',
        fontSize: 12,
        marginBottom: '10px',
        backgroundColor: 'transparent',
        color: '#4197d6',
        borderRadius: '20px',
        border: '0px',
        height: '25px',
    }
});
export var ConfirmationButton = styled(PrimaryButton)({
    marginBottom: '10px',
    border: '0px',
    color: 'white',
    borderRadius: '10px',
    height: '25px',
    minWidth: '200px',
    marginLeft: 'auto'
});
export var StartOverButton = styled(Button)({
    minWidth: '200px',
    marginBottom: '5px'
});
export var ViewImportJobButton = styled(Button)({
    minWidth: '200px',
    marginBottom: '5px'
});
export var ContinueButton = styled(Button)({
    minWidth: '200px',
    minHeight: '25px',
    marginBottom: '10px'
});
export var YesNoSelect = function (_a) {
    var onBlur = _a.onBlur, $value = _a.$value;
    var $localValue = useLinked($value.value ? 'yes' : 'no');
    useEffect(function () { return $value.set($localValue.value == 'yes'); }, [$localValue.value]);
    return React.createElement(FormSelect, __assign({}, { onBlur: onBlur }, { "$value": $localValue }),
        React.createElement(Option, { value: "yes" }, "Yes"),
        React.createElement(Option, { value: "no" }, "No"));
};
export var ErrorHighligter = function (_a) {
    var children = _a.children, error = _a.error, classes = _a.classes;
    var classAggregator = classes ? classes : makeErrorHighlighterStyles();
    return error ? React.createElement(DigiTooltip, { title: error },
        React.createElement("div", { className: classAggregator.root }, children)) : React.createElement(React.Fragment, null, children);
};
var makeErrorHighlighterStyles = makeStyles({
    root: {
        paddingLeft: '5px',
        paddingRight: '5px',
        border: '3px solid #ffdf71',
        borderRadius: '10px'
    }
});
export var DigiTooltip = withStyles({
    tooltip: {
        color: 'white',
        backgroundColor: '#3a7eac',
        padding: 10,
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 600
    },
    arrow: {
        color: '#3a7eac',
    },
})(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Tooltip, __assign({ placement: "left-end", arrow: true }, props));
});
export var ErrorsContainer = div({
    padding: '10px',
    backgroundColor: 'white',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontSize: '12px',
    color: 'red',
    border: '1px solid red',
    marginTop: '10px',
    marginBottom: '10px',
    maxHeight: '100px',
    overflow: 'scroll'
});
export var ErrorView = span({
    color: 'red',
    display: 'block'
});
export var DigiDateInput = withStyles({
    input: {
        '&.date-picker': {
            zIndex: '1000',
            paddingRight: '23px',
            marginRight: '5px',
            backgroundOrigin: 'padding-box',
            backgroundPosition: 'right 5px bottom 10px',
            flex: 1
        }
    }
})(Input);
export var DigiCheckbox = withStyles({
    checkbox: {
        width: '18px',
        height: '18px',
        '& div': {
            width: '9px',
            height: '6px',
            borderColor: 'white'
        },
        backgroundColor: function (props) { return props.checked || (props.$checked && props.$checked.value) ? '#4D9ED8' : ''; },
        cursor: function (props) { return props.readOnly || props.disabled ? 'not-allowed' : ''; },
        borderRadius: '2px'
    },
})(BaseCheckbox);
export var asTimelessLinkedDate = function ($date) { return Linked.value($date && $date.value ? new Date($date.value.getUTCFullYear(), $date.value.getUTCMonth(), $date.value.getUTCDate(), 0, 0, 0, 0) : null, function (x) { return $date.set(x ? new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate(), 0, 0, 0, 0)) : null); }); };
export var limitText = function (text, count) { return text ? text.slice(0, count) + (text.length > count ? "..." : "") : ''; };
export var poll = function (fn, fnCondition, ms) { return __awaiter(_this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fn()];
            case 1:
                result = _a.sent();
                _a.label = 2;
            case 2:
                if (!fnCondition(result)) return [3 /*break*/, 5];
                return [4 /*yield*/, wait(ms)];
            case 3:
                _a.sent();
                return [4 /*yield*/, fn()];
            case 4:
                result = _a.sent();
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/, result];
        }
    });
}); };
export var pollWithLimit = function (fn, fnCondition, ms, times) { return __awaiter(_this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fn()];
            case 1:
                result = _a.sent();
                _a.label = 2;
            case 2:
                if (!(fnCondition(result) && times > 0)) return [3 /*break*/, 5];
                return [4 /*yield*/, wait(ms)];
            case 3:
                _a.sent();
                return [4 /*yield*/, fn()];
            case 4:
                result = _a.sent();
                times--;
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/, result];
        }
    });
}); };
export var wait = function (ms) {
    if (ms === void 0) { ms = 1000; }
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
};
export var ErrorHighlighter = div({
    '& [class*="-error-"]': {
        border: '2px solid #ffdf71 !important',
        paddingLeft: '5px',
        borderRadius: '10px',
        paddingRight: '5px',
    },
    '& .error': {
        border: '2px solid #ffdf71 !important',
        paddingLeft: '5px',
        borderRadius: '10px',
        paddingRight: '5px',
        '& .select-root': {
            border: 'none !important',
        },
        '& .select-input-root': {
            border: 'none !important',
        },
        '& fieldset': {
            border: 'none !important',
        },
        '& [class*="errorIcon"]': {
            display: 'none'
        }
    },
});
export var downloadOriginalFile = function (url, fileName) { return __awaiter(_this, void 0, void 0, function () {
    var response, blob, dataUrl, a;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'GET',
                    headers: new Headers({
                        "Authorization": getAuthorizationBearer(),
                        "X-Platform-Code": getPlatformCode()
                    })
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                dataUrl = window.URL.createObjectURL(blob), a = document.createElement('a');
                a.href = dataUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                return [2 /*return*/];
        }
    });
}); };
export var downloadInvoiceCsvReportFile = function (url, dateFrom, dateTo) { return __awaiter(_this, void 0, void 0, function () {
    var response, blob, dataUrl, a;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'POST',
                    headers: new Headers({
                        "Authorization": getAuthorizationBearer(),
                        "X-Platform-Code": getPlatformCode(),
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                    }),
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                dataUrl = window.URL.createObjectURL(blob), a = document.createElement('a');
                a.href = dataUrl;
                a.download = 'invoice-report.csv';
                document.body.appendChild(a);
                a.click();
                a.remove();
                return [2 /*return*/];
        }
    });
}); };
export var preventDefaultAndStopPropagation = function (event) {
    event.preventDefault();
    event.stopPropagation();
};
//# sourceMappingURL=shared.js.map